module.exports = __webpack_public_path__ + "img/Happy_emoji-removebg-preview 1.b119b148.png";